import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getRequest, RequestOptions } from 'utils/http';

export function useRequest<T>(params: Omit<RequestOptions, 'method'>, options: UseQueryOptions<T> = {}) {
    return useQuery<T>(['request', params], () => getRequest<T>(params), options);
}
